// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/****** Spreadsheet ********/
/********** Base **********/
/********** Colours **********/
/********** Pages **********/
/********** Modal **********/
/********** Button **********/
/******* Icons ********/
/******* Icons ********/
/******* Media Queries ********/
.fadein, #save-button,
#discard-button,
#discard-all-button,
#save-all-button {
  animation: fadein 0.3s;
}

.fadeout {
  animation: fadeout 0.3s;
}

@keyframes fadein {
  from {
    opacity: 0;
    transform: translate3d(0, -0.5rem, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
*[hidden] {
  display: none;
}

.lu-container {
  height: 100%;
  width: 100%;
}

.tree {
  min-width: 220px;
  padding: 0;
}

button {
  cursor: pointer;
}

#tree-button {
  padding: 0;
  margin: auto 10px;
}

.right-container {
  height: 100%;
  width: 100%;
}

.action-container {
  display: grid;
  grid-template-columns: 30px 340px 1fr auto;
  grid-gap: 1em;
  height: 50px;
}

:host ::ng-deep mat-chip {
  margin: 0;
  min-height: 12px;
  border-radius: 4px;
  padding-right: 4px;
}

/* TODO(mdc-migration): The following rule targets internal classes of chips that may no longer apply for the MDC version.*/
:host ::ng-deep .mat-chip-list-wrapper {
  display: inline-flex !important;
  flex-wrap: nowrap;
}

.panel-main-header-center {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  max-height: 44px;
  overflow: hidden;
  margin-top: 20px;
  margin-bottom: 16px;
}

.filter-chip {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
}

.filter-chip > div {
  margin-bottom: 4px;
  width: 100%;
  text-align: center;
}

.clear-scenario-filter {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  line-height: 20px;
  text-align: center;
  margin: 0 auto;
  margin-right: 0;
  color: rgba(255, 255, 255, 0.5);
  font-size: 20px;
  padding-left: 10px;
  cursor: pointer;
}
.clear-scenario-filter:hover {
  color: rgba(255, 255, 255, 0.75);
}

:host ::ng-deep .mat-mdc-select-panel {
  overflow-x: hidden;
}

/* TODO(mdc-migration): The following rule targets internal classes of option that may no longer apply for the MDC version.*/
mat-option {
  padding: 4px 4px;
}

:host ::ng-deep .mat-option {
  height: auto !important;
  line-height: 1.5 !important;
  padding: 12px 16px !important;
  font-size: 14px !important;
}

:host ::ng-deep .mat-option:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

:host ::ng-deep .mat-option.mat-selected {
  background-color: rgba(63, 81, 181, 0.12) !important;
}

:host ::ng-deep .mat-select-panel {
  border-radius: 4px !important;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12) !important;
}

.loading {
  filter: blur(4px);
}

.action-buttons-container {
  display: grid;
  grid-template-columns: auto auto auto;
  padding: 6px;
  margin: auto;
  height: 2rem;
}

#save-button,
#save-all-button {
  display: grid;
  max-height: 3.25em;
  background-color: #5b9b35;
  border-color: #5b9b35;
  color: white;
}

.button-content {
  display: grid;
  grid-template-columns: auto auto;
  grid-template-rows: 1fr;
  grid-gap: 10px;
  margin: auto;
}

.button-content mat-spinner {
  margin: auto;
}

#refresh-button {
  box-shadow: none;
  height: 3.4em;
  width: 3.4em;
}

/* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version.*/
:host ::ng-deep span.mat-button-wrapper {
  padding: 6px;
  line-height: unset;
}

.closed {
  display: none;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 50;
  background: rgba(0, 0, 0, 0.6);
}

.modal-guts {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 20px 60px 20px 20px;
}

.debugging {
  position: fixed;
  background: darksalmon;
  padding: 1em;
  bottom: 100px;
  left: 480px;
  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.5);
}

.tree--visible {
  border: 2px solid tomato;
}

.panel-left {
  width: 18rem !important;
  min-width: 18rem !important;
  max-width: 18rem !important;
}

.panel-main {
  width: calc(100% - 18rem) !important;
}
.panel-main .panel-main-header {
  min-height: 56px !important;
  display: flex;
  align-items: center;
}
.panel-main .panel-main-header-left {
  display: flex;
  align-items: center;
  height: 100%;
  max-height: 56px;
}
.panel-main .panel-main-body {
  margin-top: 5px;
}
.panel-main .panel-main-body .processing {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 4px;
  border: solid 2px;
  color: #51738b;
  font-size: 2rem;
  height: 4rem;
  left: 50%;
  line-height: 4rem;
  opacity: 0;
  padding: 0rem 2rem 1rem;
  pointer-events: none;
  position: fixed;
  text-align: center;
  top: calc(50% - 2rem);
  transition: opacity 0.5s ease-in-out;
  width: -moz-fit-content;
  width: fit-content;
  z-index: 9;
}
.panel-main .panel-main-body .processing.display {
  opacity: 1;
}

#toggle_list_btn_container {
  margin: auto;
  margin-left: 0;
  margin-right: 0.5rem;
}

.panel-main-header-right {
  margin: auto 1rem !important;
}

#save-button,
#save-all-button {
  margin-left: 0.618em;
}

.panel-main-header,
.panel-main-header-left {
  overflow: visible !important;
}

:host ::ng-deep .mat-mdc-select-panel,
:host ::ng-deep .mat-select-panel {
  z-index: 1000 !important;
}

:host ::ng-deep mat-form-field {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  min-width: 180px;
  display: flex;
  align-items: center;
}

:host ::ng-deep .mat-form-field-wrapper {
  padding-bottom: 0 !important;
}

:host ::ng-deep .mat-form-field-underline {
  bottom: 0 !important;
}

:host ::ng-deep .mat-form-field-infix {
  padding: 0.5em 0 !important;
  border-top: 0.5em solid transparent !important;
}

:host ::ng-deep .mat-select-value {
  color: rgba(0, 0, 0, 0.87) !important;
  font-size: 14px !important;
}

:host ::ng-deep .mat-select-placeholder {
  color: rgba(0, 0, 0, 0.38) !important;
  font-size: 14px !important;
}

:host ::ng-deep .mat-select {
  display: flex;
  align-items: center;
}

:host ::ng-deep mat-chip-option {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: auto !important;
  margin: 0 auto !important;
  min-width: 0 !important;
  max-width: 100% !important;
}

:host ::ng-deep .mat-chip-option .mat-icon,
:host ::ng-deep .mat-chip-option .mat-mdc-chip-checkmark,
:host ::ng-deep .mat-chip-option .mat-chip-checkmark,
:host ::ng-deep .mat-chip-option .mat-mdc-chip-leading-icon,
:host ::ng-deep .mat-chip-option svg,
:host ::ng-deep .mat-chip-option [role=img],
:host ::ng-deep .mat-chip-option .mat-chip-avatar,
:host ::ng-deep .mat-chip-option .mat-mdc-chip-trailing-icon,
:host ::ng-deep .mat-chip-option .mat-mdc-chip-graphic {
  display: none !important;
}

:host ::ng-deep .mat-chip-option > .mat-icon,
:host ::ng-deep .mat-chip-option > svg,
:host ::ng-deep .mat-chip-option > [role=img] {
  display: none !important;
}

:host ::ng-deep .mat-chip-option::before,
:host ::ng-deep .mat-chip-option::after {
  display: none !important;
  content: none !important;
}

:host ::ng-deep .select-style .mat-select-panel {
  max-height: 300px !important;
  border-radius: 4px !important;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12) !important;
}
:host ::ng-deep .select-style .mat-option {
  height: auto !important;
  line-height: 1.5 !important;
  padding: 12px 16px !important;
  font-size: 14px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}
:host ::ng-deep .select-style .mat-option:last-child {
  border-bottom: none !important;
}
:host ::ng-deep .select-style .mat-option:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}
:host ::ng-deep .select-style .mat-option.mat-selected {
  background-color: rgba(63, 81, 181, 0.12) !important;
}

:host ::ng-deep mat-chip-listbox {
  display: flex !important;
  justify-content: center !important;
  width: 100%;
}

:host ::ng-deep .mdc-evolution-chip__checkmark,
:host ::ng-deep .mdc-evolution-chip__checkmark-svg,
:host ::ng-deep .mdc-evolution-chip__checkmark-path {
  display: none !important;
}

:host ::ng-deep .mdc-evolution-chip-set__chips {
  display: flex !important;
  justify-content: center !important;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/styles/base/_variables.scss","webpack://./src/app/styles/base/common/_animations.scss","webpack://./src/app/components/model-data/lookup-data/lookup-data.component.scss"],"names":[],"mappings":"AAEA,4BAAA;AAOA,2BAAA;AAkBA,8BAAA;AAgDA,4BAAA;AAEA,4BAAA;AAGA,6BAAA;AAWA,uBAAA;AAgBA,uBAAA;AAEA,+BAAA;AChEA;;;;EACE,sBAAA;AChCF;;ADkCA;EACE,uBAAA;AC/BF;;ADkCA;EACE;IACE,UAAA;IACA,qCAAA;EC/BF;EDiCA;IACE,UAAA;IACA,+BAAA;EC/BF;AACF;ADiCA;EACE;IACE,UAAA;EC/BF;EDiCA;IACE,UAAA;EC/BF;AACF;AAlCA;EACE,aAAA;AAoCF;;AAjCA;EAEE,YAAA;EACA,WAAA;AAmCF;;AAhCA;EACE,gBAAA;EACA,UAAA;AAmCF;;AAhCA;EACE,eAAA;AAmCF;;AAhCA;EACE,UAAA;EACA,iBAAA;AAmCF;;AAhCA;EACE,YAAA;EACA,WAAA;AAmCF;;AAhCA;EACE,aAAA;EACA,0CAAA;EACA,aAAA;EACA,YAAA;AAmCF;;AA/BA;EACE,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAkCF;;AA/BA,2HAAA;AACA;EACE,+BAAA;EACA,iBAAA;AAkCF;;AA/BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAkCF;;AA/BA;EACE,8BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AAkCF;;AA/BA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;AAkCF;;AA/BA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AAkCF;AAjCE;EACE,gCAAA;AAmCJ;;AA/BA;EACE,kBAAA;AAkCF;;AA/BA,4HAAA;AACA;EACE,gBAAA;AAkCF;;AA9BA;EACE,uBAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;AAiCF;;AA9BA;EACE,gDAAA;AAiCF;;AA9BA;EACE,oDAAA;AAiCF;;AA9BA;EACE,6BAAA;EACA,2HAAA;AAiCF;;AA9BA;EACE,iBAAA;AAiCF;;AA9BA;EACE,aAAA;EACA,qCAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;AAiCF;;AA9BA;;EAEE,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;AAiCF;;AA9BA;EACE,aAAA;EACA,gCAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;AAiCF;;AA/BA;EACE,YAAA;AAkCF;;AA/BA;EACE,gBAAA;EACA,aAAA;EACA,YAAA;AAkCF;;AAhCA,4HAAA;AACA;EACE,YAAA;EACA,kBAAA;AAmCF;;AAhCA;EACE,aAAA;AAmCF;;AAhCA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EAEA,8BAAA;AAkCF;;AAhCA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,4BAAA;AAmCF;;AAhCA;EACE,eAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,0CAAA;AAmCF;;AAhCA;EACE,wBAAA;AAmCF;;AAhCA;EACE,uBAAA;EACA,2BAAA;EACA,2BAAA;AAmCF;;AAhCA;EAEE,oCAAA;AAkCF;AAhCE;EACE,2BAAA;EACA,aAAA;EACA,mBAAA;AAkCJ;AA/BE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AAiCJ;AA9BE;EACE,eAAA;AAgCJ;AA9BI;EACE,qCAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,oCAAA;EACA,uBAAA;EAAA,kBAAA;EACA,UAAA;AAgCN;AA9BM;EACE,UAAA;AAgCR;;AA1BA;EACE,YAAA;EACA,cAAA;EACA,oBAAA;AA6BF;;AA1BA;EACE,4BAAA;AA6BF;;AA1BA;;EAEE,oBAAA;AA6BF;;AAnBA;;EAEE,4BAAA;AAsBF;;AAnBA;;EAEE,wBAAA;AAsBF;;AAnBA;EACE,wBAAA;EACA,2BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAsBF;;AAlBA;EACE,4BAAA;AAqBF;;AAlBA;EACE,oBAAA;AAqBF;;AAlBA;EACE,2BAAA;EACA,8CAAA;AAqBF;;AAlBA;EACE,qCAAA;EACA,0BAAA;AAqBF;;AAlBA;EACE,qCAAA;EACA,0BAAA;AAqBF;;AAlBA;EACE,aAAA;EACA,mBAAA;AAqBF;;AAlBA;EACE,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;EACA,uBAAA;EACA,0BAAA;AAqBF;;AAlBA;;;;;;;;;EASE,wBAAA;AAqBF;;AAnBA;;;EAGE,wBAAA;AAsBF;;AApBA;;EAEE,wBAAA;EACA,wBAAA;AAuBF;;AAlBE;EACE,4BAAA;EACA,6BAAA;EACA,2HAAA;AAqBJ;AAlBE;EACE,uBAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,uDAAA;AAoBJ;AAlBI;EACE,8BAAA;AAoBN;AAjBI;EACE,gDAAA;AAmBN;AAhBI;EACE,oDAAA;AAkBN;;AAbA;EACE,wBAAA;EACA,kCAAA;EACA,WAAA;AAgBF;;AAbA;;;EAGE,wBAAA;AAgBF;;AAbA;EACE,wBAAA;EACA,kCAAA;EACA,WAAA;AAgBF","sourcesContent":["// @import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,300i,400,400i,600,600i,700,700i');\r\n\r\n/****** Spreadsheet ********/\r\n\r\n// $spread-sheet-height: 67vh;\r\n$spread-sheet-height: 100%;\r\n$padding: 0.7rem;\r\n$tree-width: 18rem;\r\n\r\n/********** Base **********/\r\n\r\n$base_color: #505050;\r\n$body_background: #ffffff;\r\n$font_pack: 'Source Sans Pro', Helvetica, sans-serif;\r\n$font_size: 0.86rem;\r\n$btn_font_size: 0.76rem;\r\n$app_color: $base_color;\r\n$border_color: #dfe0e1;\r\n$placeholder-color: rgba(#000000, 0.4);\r\n$placeholder-color-white: #ffffff;\r\n$input_background: #ffffff;\r\n$input_background_readonly: #eef0f1; //#EEF0F1\r\n$input_border: #ababab;\r\n$input_border_focus: #505050;\r\n$input_border_expected: #ffcd40;\r\n$input_required: rgba(#f8e71c, 0.3);\r\n\r\n/********** Colours **********/\r\n\r\n$primary_color: #72bf44;\r\n\r\n$black: #000000;\r\n$white: #ffffff;\r\n\r\n$grey_1: #4a4a4a;\r\n$grey_2: #585d69;\r\n$grey_3: #5d6978;\r\n\r\n$lighter_grey: #f5f6f7;\r\n$light_grey: #eceef3;\r\n$grey: #cccccc;\r\n$mid_grey: #7e8c99;\r\n$dark_grey: #525b6b;\r\n$darker_grey: #464c59;\r\n\r\n$disabled_grey: #ababab;\r\n$blue: #51738b; //#04BBEE\r\n$navy: #2b495e;\r\n\r\n$red: #ea5441;\r\n$green: #72bf44;\r\n$orange: #f07d23;\r\n$yellow: #ffcd40;\r\n\r\n$state_hover: rgba($blue, 0.1);\r\n\r\n$shadow_1: rgba($grey_1, 0.2);\r\n$shadow_2: rgba($black, 0.2);\r\n\r\n$row_hover: #f4f6f7;\r\n\r\n$group_color_1: #a7c5e5;\r\n$group_color_2: #d39fe9;\r\n$group_color_3: #e9e19f;\r\n$group_color_4: #9a75ff;\r\n$group_color_5: #a7e5b4;\r\n$group_color_6: #adb1c7;\r\n$group_color_7: #fa8d8d;\r\n$group_color_8: #ffc375;\r\n\r\n$notification: #ff9d00;\r\n$notification_light: rgba($notification, 0.25);\r\n\r\n$tree_btn_hover: #f4f6f7;\r\n\r\n/********** Pages **********/\r\n\r\n/********** Modal **********/\r\n$modal_background: #ffffff;\r\n\r\n/********** Button **********/\r\n$btn_primary_bg: #72bf44;\r\n$btn_primary_bg_hover: darken($btn_primary_bg, 10%);\r\n$btn_primary_color: #ffffff;\r\n$btn_primary_color_hover: #ffffff;\r\n\r\n$btn_secondary_bg: #51738b;\r\n$btn_secondary_bg_hover: darken($btn_secondary_bg, 10%);\r\n$btn_secondary_color: #ffffff;\r\n$btn_secondary_color_hover: #ffffff;\r\n\r\n/******* Icons ********/\r\n\r\n$empyrean_logo: '\\e905';\r\n$sheet_loader: '\\e90d';\r\n$triangle_right: '\\e910';\r\n$valid: '\\e922';\r\n$warning: '\\e923';\r\n$error: '\\e91f';\r\n$chevron_left: '\\e901';\r\n$chevron_right: '\\e902';\r\n$chevron_up: '\\e903';\r\n$chevron_down: '\\e900';\r\n\r\n$x: -50%;\r\n$y: -50%;\r\n\r\n/******* Icons ********/\r\n\r\n/******* Media Queries ********/\r\n\r\n$mobile: '(min-width: 0px) and (max-width: 767px)';\r\n$mobile_portrait: '(min-width: 0px) and (max-width: 767px) and (orientation: portrait)';\r\n$mobile_landscape: '(min-width: 320px) and (max-width: 767px) and (orientation: landscape)';\r\n\r\n$tablet: '(min-width: 768px) and (max-width: 1024px)';\r\n$tablet_portrait: '(min-width: 768px) and (max-width: 1023px) and (orientation: portrait)';\r\n$tablet_landscape: '(min-width: 1024px) and (max-width: 1279px)';\r\n\r\n$desktop: '(min-width: 1025px) and (max-width: 1439px)';\r\n$desktop_wide: '(min-width: 1440px)';\r\n$desktop_extra_wide: '(min-width: 1680px)';\r\n$min_desktop_wide: '(min-width: 1280px)';\r\n\r\n$max_height: '(max-height: 760px)';\r\n","// // Common properties\r\n// .animation {\r\n//   animation-duration: 1s;\r\n//   animation-fill-mode: forwards;\r\n//   animation-timing-function: ease-in-out;\r\n// }\r\n\r\n// // APPEAR\r\n\r\n// .appear {\r\n//   @extend .animation;\r\n//   height: 100%;\r\n//   animation-name: appearAnimation;\r\n// }\r\n\r\n// @keyframes appearAnimation {\r\n//   0% {\r\n//     height: 0%;\r\n//     // top: -100%;\r\n//   }\r\n//   100% {\r\n//     height: 100%;\r\n//     // top: 0;\r\n//   }\r\n// }\r\n\r\n// // DISAPPEAR\r\n\r\n// .disappear {\r\n//   @extend .animation;\r\n//   height: 0%;\r\n//   animation-name: disappearAnimation;\r\n// }\r\n\r\n// @keyframes disappearAnimation {\r\n//   0% {\r\n//     // top: 0;\r\n//     height: 100%;\r\n//   }\r\n//   100% {\r\n//     // top: -100%;\r\n//     height: 0;\r\n//   }\r\n// }\r\n\r\n.fadein {\r\n  animation: fadein 0.3s;\r\n}\r\n.fadeout {\r\n  animation: fadeout 0.3s;\r\n}\r\n\r\n@keyframes fadein {\r\n  from {\r\n    opacity: 0;\r\n    transform: translate3d(0, -0.5rem, 0);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translate3d(0, 0, 0);\r\n  }\r\n}\r\n@keyframes fadeout {\r\n  from {\r\n    opacity: 1;\r\n  }\r\n  to {\r\n    opacity: 0;\r\n  }\r\n}\r\n","@import '../../../styles/base/variables';\r\n@import '../../../styles/base/common/animations';\r\n\r\n*[hidden] {\r\n  display: none;\r\n}\r\n\r\n.lu-container {\r\n  // height: calc(100vh - 9.4em);\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.tree {\r\n  min-width: 220px;\r\n  padding: 0;\r\n}\r\n\r\nbutton {\r\n  cursor: pointer;\r\n}\r\n\r\n#tree-button {\r\n  padding: 0;\r\n  margin: auto 10px;\r\n}\r\n\r\n.right-container {\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.action-container {\r\n  display: grid;\r\n  grid-template-columns: 30px 340px 1fr auto;\r\n  grid-gap: 1em;\r\n  height: 50px;\r\n  // align-items: baseline;\r\n}\r\n\r\n:host ::ng-deep mat-chip {\r\n  margin: 0;\r\n  min-height: 12px;\r\n  border-radius: 4px;\r\n  padding-right: 4px;\r\n}\r\n\r\n/* TODO(mdc-migration): The following rule targets internal classes of chips that may no longer apply for the MDC version.*/\r\n:host ::ng-deep .mat-chip-list-wrapper {\r\n  display: inline-flex !important;\r\n  flex-wrap: nowrap;\r\n}\r\n\r\n.panel-main-header-center {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  max-height: 44px;\r\n  overflow: hidden;\r\n  margin-top: 20px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.filter-chip {\r\n  background: rgba(0, 0, 0, 0.1);\r\n  border-radius: 4px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n.filter-chip > div {\r\n  margin-bottom: 4px;\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n.clear-scenario-filter {\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 50%;\r\n  line-height: 20px;\r\n  text-align: center;\r\n  margin: 0 auto;\r\n  margin-right: 0;\r\n  color: rgba(255, 255, 255, 0.5);\r\n  font-size: 20px;\r\n  padding-left: 10px;\r\n  cursor: pointer;\r\n  &:hover {\r\n    color: rgba(255, 255, 255, 0.75);\r\n  }\r\n}\r\n\r\n:host ::ng-deep .mat-mdc-select-panel {\r\n  overflow-x: hidden;\r\n}\r\n\r\n/* TODO(mdc-migration): The following rule targets internal classes of option that may no longer apply for the MDC version.*/\r\nmat-option {\r\n  padding: 4px 4px;\r\n}\r\n\r\n// Add proper Material Design styling for select options\r\n:host ::ng-deep .mat-option {\r\n  height: auto !important;\r\n  line-height: 1.5 !important;\r\n  padding: 12px 16px !important;\r\n  font-size: 14px !important;\r\n}\r\n\r\n:host ::ng-deep .mat-option:hover {\r\n  background-color: rgba(0, 0, 0, 0.04) !important;\r\n}\r\n\r\n:host ::ng-deep .mat-option.mat-selected {\r\n  background-color: rgba(63, 81, 181, 0.12) !important;\r\n}\r\n\r\n:host ::ng-deep .mat-select-panel {\r\n  border-radius: 4px !important;\r\n  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12) !important;\r\n}\r\n\r\n.loading {\r\n  filter: blur(4px);\r\n}\r\n\r\n.action-buttons-container {\r\n  display: grid;\r\n  grid-template-columns: auto auto auto;\r\n  padding: 6px;\r\n  margin: auto;\r\n  height: 2rem;\r\n}\r\n\r\n#save-button,\r\n#save-all-button {\r\n  display: grid;\r\n  max-height: 3.25em;\r\n  background-color: #5b9b35;\r\n  border-color: #5b9b35;\r\n  color: white;\r\n}\r\n\r\n.button-content {\r\n  display: grid;\r\n  grid-template-columns: auto auto;\r\n  grid-template-rows: 1fr;\r\n  grid-gap: 10px;\r\n  margin: auto;\r\n}\r\n.button-content mat-spinner {\r\n  margin: auto;\r\n}\r\n\r\n#refresh-button {\r\n  box-shadow: none;\r\n  height: 3.4em;\r\n  width: 3.4em;\r\n}\r\n/* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version.*/\r\n:host ::ng-deep span.mat-button-wrapper {\r\n  padding: 6px;\r\n  line-height: unset;\r\n}\r\n\r\n.closed {\r\n  display: none;\r\n}\r\n\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 50;\r\n\r\n  background: rgba(0, 0, 0, 0.6);\r\n}\r\n.modal-guts {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: auto;\r\n  padding: 20px 60px 20px 20px;\r\n}\r\n\r\n.debugging {\r\n  position: fixed;\r\n  background: darksalmon;\r\n  padding: 1em;\r\n  bottom: 100px;\r\n  left: 480px;\r\n  box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.tree--visible {\r\n  border: 2px solid tomato;\r\n}\r\n\r\n.panel-left {\r\n  width: $tree-width !important;\r\n  min-width: $tree-width !important;\r\n  max-width: $tree-width !important;\r\n}\r\n\r\n.panel-main {\r\n  // $tree-width : 18rem\r\n  width: #{calc(100% - 18rem)} !important;\r\n\r\n  .panel-main-header {\r\n    min-height: 56px !important;\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n\r\n  .panel-main-header-left {\r\n    display: flex;\r\n    align-items: center;\r\n    height: 100%;\r\n    max-height: 56px; // Match header height\r\n  }\r\n\r\n  .panel-main-body {\r\n    margin-top: 5px;\r\n    \r\n    .processing {\r\n      background: rgba(255, 255, 255, 0.95);\r\n      border-radius: 4px;\r\n      border: solid 2px;\r\n      color: #51738b;\r\n      font-size: 2rem;\r\n      height: 4rem;\r\n      left: calc(50%);\r\n      line-height: 4rem;\r\n      opacity: 0;\r\n      padding: 0rem 2rem 1rem;\r\n      pointer-events: none;\r\n      position: fixed;\r\n      text-align: center;\r\n      top: calc(50% - 2rem);\r\n      transition: opacity 0.5s ease-in-out;\r\n      width: fit-content;\r\n      z-index: 9;\r\n\r\n      &.display {\r\n        opacity: 1;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n#toggle_list_btn_container {\r\n  margin: auto;\r\n  margin-left: 0;\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.panel-main-header-right {\r\n  margin: auto 1rem !important;\r\n}\r\n\r\n#save-button,\r\n#save-all-button {\r\n  margin-left: 0.618em;\r\n}\r\n\r\n#save-button,\r\n#discard-button,\r\n#discard-all-button,\r\n#save-all-button {\r\n  @extend .fadein;\r\n}\r\n\r\n.panel-main-header,\r\n.panel-main-header-left {\r\n  overflow: visible !important;\r\n}\r\n\r\n:host ::ng-deep .mat-mdc-select-panel,\r\n:host ::ng-deep .mat-select-panel {\r\n  z-index: 1000 !important;\r\n}\r\n\r\n:host ::ng-deep mat-form-field {\r\n  margin-top: 0 !important;\r\n  margin-bottom: 0 !important;\r\n  min-width: 180px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n// Add proper Material Design form field styling\r\n:host ::ng-deep .mat-form-field-wrapper {\r\n  padding-bottom: 0 !important;\r\n}\r\n\r\n:host ::ng-deep .mat-form-field-underline {\r\n  bottom: 0 !important;\r\n}\r\n\r\n:host ::ng-deep .mat-form-field-infix {\r\n  padding: 0.5em 0 !important;\r\n  border-top: 0.5em solid transparent !important;\r\n}\r\n\r\n:host ::ng-deep .mat-select-value {\r\n  color: rgba(0, 0, 0, 0.87) !important;\r\n  font-size: 14px !important;\r\n}\r\n\r\n:host ::ng-deep .mat-select-placeholder {\r\n  color: rgba(0, 0, 0, 0.38) !important;\r\n  font-size: 14px !important;\r\n}\r\n\r\n:host ::ng-deep .mat-select {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n:host ::ng-deep mat-chip-option {\r\n  display: inline-flex !important;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: auto !important;\r\n  margin: 0 auto !important;\r\n  min-width: 0 !important;\r\n  max-width: 100% !important;\r\n}\r\n\r\n:host ::ng-deep .mat-chip-option .mat-icon,\r\n:host ::ng-deep .mat-chip-option .mat-mdc-chip-checkmark,\r\n:host ::ng-deep .mat-chip-option .mat-chip-checkmark,\r\n:host ::ng-deep .mat-chip-option .mat-mdc-chip-leading-icon,\r\n:host ::ng-deep .mat-chip-option svg,\r\n:host ::ng-deep .mat-chip-option [role=\"img\"],\r\n:host ::ng-deep .mat-chip-option .mat-chip-avatar,\r\n:host ::ng-deep .mat-chip-option .mat-mdc-chip-trailing-icon,\r\n:host ::ng-deep .mat-chip-option .mat-mdc-chip-graphic {\r\n  display: none !important;\r\n}\r\n:host ::ng-deep .mat-chip-option > .mat-icon,\r\n:host ::ng-deep .mat-chip-option > svg,\r\n:host ::ng-deep .mat-chip-option > [role=\"img\"] {\r\n  display: none !important;\r\n}\r\n:host ::ng-deep .mat-chip-option::before,\r\n:host ::ng-deep .mat-chip-option::after {\r\n  display: none !important;\r\n  content: none !important;\r\n}\r\n\r\n// Style for the select-style panel class\r\n:host ::ng-deep .select-style {\r\n  .mat-select-panel {\r\n    max-height: 300px !important;\r\n    border-radius: 4px !important;\r\n    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12) !important;\r\n  }\r\n  \r\n  .mat-option {\r\n    height: auto !important;\r\n    line-height: 1.5 !important;\r\n    padding: 12px 16px !important;\r\n    font-size: 14px !important;\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;\r\n    \r\n    &:last-child {\r\n      border-bottom: none !important;\r\n    }\r\n    \r\n    &:hover {\r\n      background-color: rgba(0, 0, 0, 0.04) !important;\r\n    }\r\n    \r\n    &.mat-selected {\r\n      background-color: rgba(63, 81, 181, 0.12) !important;\r\n    }\r\n  }\r\n}\r\n\r\n:host ::ng-deep mat-chip-listbox {\r\n  display: flex !important;\r\n  justify-content: center !important;\r\n  width: 100%;\r\n}\r\n\r\n:host ::ng-deep .mdc-evolution-chip__checkmark,\r\n:host ::ng-deep .mdc-evolution-chip__checkmark-svg,\r\n:host ::ng-deep .mdc-evolution-chip__checkmark-path {\r\n  display: none !important;\r\n}\r\n\r\n:host ::ng-deep .mdc-evolution-chip-set__chips {\r\n  display: flex !important;\r\n  justify-content: center !important;\r\n  width: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
